var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name !== 'login' 
    && _vm.$route.name !== 'Lupa Password' 
    && _vm.$route.name !== 'Auto Login'
    && _vm.$route.name !== '404')?_c('Navbar'):_vm._e(),_c('v-main',{attrs:{"min-height":"100vh","light":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }